var map = {
	"./Schulwegtrainer_RF_01_F_221216_1E.svg": 6021,
	"./Schulwegtrainer_RF_01_R_221216_1E.svg": 5975,
	"./Schulwegtrainer_RF_02_F_221216_1E.svg": 9686,
	"./Schulwegtrainer_RF_02_R_221216_1E.svg": 4344,
	"./Schulwegtrainer_RF_04_F_221216_1E.svg": 4397,
	"./Schulwegtrainer_RF_04_R_221216_1E.svg": 7806,
	"./Schulwegtrainer_RF_05_F_221216_1E.svg": 3969,
	"./Schulwegtrainer_RF_05_R_221216_1E.svg": 2054,
	"./Schulwegtrainer_RF_06_F_221216_1E.svg": 8915,
	"./Schulwegtrainer_RF_06_R_221216_1E.svg": 8022,
	"./Schulwegtrainer_RF_07_F_221216_1E.svg": 1920,
	"./Schulwegtrainer_RF_07_R_221216_1E.svg": 4210,
	"./Schulwegtrainer_RF_08_F_221216_1E.svg": 4484,
	"./Schulwegtrainer_RF_08_R_221216_1E.svg": 3260,
	"./Schulwegtrainer_RF_09_F_221216_1E.svg": 9101,
	"./Schulwegtrainer_RF_09_R_221216_1E.svg": 9876,
	"./Schulwegtrainer_RF_10_F_221216_1E.svg": 5683,
	"./Schulwegtrainer_RF_10_R_221216_1E.svg": 1525,
	"./Schulwegtrainer_RF_11_F_221216_1E.svg": 7927,
	"./Schulwegtrainer_RF_11_R_221216_1E.svg": 971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7088;